// CPF have some very specific rules
// Used function from this lib: https://www.npmjs.com/package/validar-cpf?activeTab=code
const isRepeatingNumber = (str) => /^(\d)(\1){10}$/.test(str);
// Input must be string as number can start or finish with 0
export const validateCpf = (input) => {
    const cpf = input.replace(/\D/g, '');
    if (cpf === '' || cpf.length !== 11 || !/^\d{11}$/.test(cpf) || isRepeatingNumber(cpf)) {
        return false;
    }
    const digits = cpf.split('').map((x) => parseInt(x));
    for (let j = 0; j < 2; j++) {
        let sum = 0;
        for (let i = 0; i < 9 + j; i++) {
            sum += digits[i] * (10 + j - i);
        }
        let checkDigit = 11 - (sum % 11);
        if (checkDigit === 10 || checkDigit === 11) {
            checkDigit = 0;
        }
        if (checkDigit !== digits[9 + j]) {
            return false;
        }
    }
    return true;
};
